import { Button, Card, Result } from 'antd';
import React from 'react';

const DEFAULT_MESSAGE = 'Sorry, something went wrong.';

// Simple Card to display Error Page. Accepts either an explicit `errorMessage`
// or an `error` object (e.g. an ApolloError), whose `message` is shown when no
// explicit message is given.
const ErrorPage = ({ error, errorCode = '500', errorMessage }) => {
  const message = errorMessage || error?.message || DEFAULT_MESSAGE;

  return (
    <Card>
      <Result
        status={errorCode}
        title={errorCode}
        subTitle={message}
        extra={
          errorCode === '403' ? (
            <Button onClick={() => (window.location.href = '/')} type="primary" href="/">
              Go to Home
            </Button>
          ) : (
            <Button onClick={() => window.location.reload()} type="primary">
              Reload
            </Button>
          )
        }
      />
    </Card>
  );
};

export default ErrorPage;
